/**
 * Determines whether a sampled event should be sent based on given rate.
 * @param {int} rate Rate as an integer percentage.
 * @returns {boolean}
 */
export const shouldSampleEvent = (rate) => {
	return Math.random() * 100 < rate;
};

// Only send 10% of content resolver events
export const CONTENT_RESOLVER_SAMPLE_RATE = 10;
